function leer(nombre: string, valor: string | undefined): string {
  if (!valor) {
    throw new Error(`Falta la variable ${nombre} en el .env (ver .env.example).`);
  }
  return valor;
}

export const env = {
  supabaseUrl: leer('VITE_SUPABASE_URL', import.meta.env.VITE_SUPABASE_URL),
  supabaseKey: leer('VITE_SUPABASE_PUBLISHABLE_KEY', import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY),
} as const;
